<template>
    <canvas ref="canvasRef" />
</template>
<script>
import { Chart as ChartJS, Title, Tooltip, Legend, LineController, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, LineController, LineElement, CategoryScale, LinearScale, PointElement)

export default {
    name: 'chart-line',
    props: {
        chartData: {
            type: Object,
            required: true
          },
        chartOptions: {
          type: Object,
          default: () => {}
        }
    },
    data() {
        return {
             chartInstance: null
        }
    },
    watch: {
      chartData(newData) {
        this.chartInstance.data = newData
        this.chartInstance.update()
      },
      chartOptions(newOptions) {
        this.chartInstance.options = newOptions
        this.chartInstance.update()
      }
    },
    mounted() {
        this.chartInstance = new ChartJS(this.$refs.canvasRef, {
            type: 'line',
            data: this.chartData,
            options: this.chartOptions
          })
    },
    beforeUnmount() {
        this.chartInstance?.destroy()
    }
}
</script>